/**
 * Traffic sources a hit can arrive with — the `source_type` enum, all eighteen.
 *
 * Deliberately not `SOURCE_DEFS` from `campaigns`: that list is the fifteen a
 * campaign can switch on, and it is shorter on purpose. A hit is labelled with
 * whatever it actually came from, which includes `direct`, `organic` and
 * `unknown` — none of which is a setting anyone turns on, and all of which show
 * up in the log. Filtering by a list that cannot express them would quietly hide
 * rows.
 *
 * Labels come from this feature's own i18n (`source.*`), which already carries
 * all eighteen keys.
 */
export const LEAD_SOURCE_KEYS = [
  'google_search',
  'google_ads',
  'meta_ads',
  'facebook',
  'instagram',
  'reddit',
  'reddit_ads',
  'x',
  'x_ads',
  'bing_search',
  'bing_ads',
  'yandex_search',
  'yandex_ads',
  'telegram',
  'whatsapp',
  'direct',
  'organic',
  'unknown',
] as const

export type LeadSource = (typeof LEAD_SOURCE_KEYS)[number]
